<template>
  <div class="flex-1 container" style="padding: 0 !important; margin: 0 !important;">
    <div class="row" style="padding: 0 !important; margin: 0 !important;">
      <div class="col-md-12" style="padding: 0 !important; margin: 0 !important;">
        <div class="form-group" style="margin-bottom: 6px; padding: 0 !important;">
          <label for="track">Трек-номер:</label>
          <input type="text" class="form-control" id="track" v-model="track">
        </div>
        <div class="form-group" style="margin-bottom: 6px; padding: 0 !important;">
          <label for="select_track">Транспортная компания:</label>
          <select class="form-control col-md-12" id="select_track" v-model="company">
            <option v-for="(el, i) in companies" :key="i" :value="el.ID">{{ el.VALUE }}</option>
          </select>
        </div>
        <div class="flexRow">
          <button type="button" class="btn btn-primary" @click="checkTrack">
            <span v-if="isLoad" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span v-if="!isLoad">Проверить</span>
          </button>
          <div class="status" id="status" v-bind:class="statusClass">{{ alertMessage }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bitrix24 from '@/lib/Bitrix24.js'
import config from '@/../config.js'
import axios from 'axios'
import app_config from '@/app_config'
import common from '@/lib/common'
import urls from '@/lib/urls'

export default {
  data() {
    return {
      company: '',
      track: '',
      companies: [],
      alertMessage: '',
      statusClass: '',
      isLoad: false,
    }
  },
  async created() {
    await this.loadFieldsData()
    let userFieldsList = await Bitrix24.callMethod('crm.deal.userfield.list', {})
    if(userFieldsList){
      let trk_transit = userFieldsList.answer.result.find(field => field.FIELD_NAME === 'UF_CRM_TRK_TRANSIT')
      if(trk_transit){
        this.companies = trk_transit.LIST
      }
    }
  },
  methods: {
    async loadFieldsData(){
      const self = this
      // информация о карточке
      let placementInfo = await Bitrix24.placementInfo()
      if(placementInfo){
        let placement = placementInfo.placement
        let card_id = ''
        if(placement === 'USERFIELD_TYPE'){
          card_id = placementInfo.options.ENTITY_VALUE_ID
          placement = placementInfo.options.ENTITY_ID+'_FIELDS'
        } else{
          card_id = placementInfo.options.ID
        }

        let card_fields = await Bitrix24.checkIsFields(placement)
        // если поля есть, то заносим данные
        if(card_fields.is_fields){
          let fields = await Bitrix24.callMethod('crm.'+card_fields.placement_type+'.get', { id: card_id })
          if(fields){
            this.company = fields.answer.result.UF_CRM_TRK_TRANSIT
            this.track = fields.answer.result.UF_CRM_TRK_TRACKER
          }
        }
      }
    },

    async saveDataInFields(){
      const self = this

      // информация о карточке
      let placementInfo = BX24.placement.info()
      let placement = placementInfo.placement
      let card_id = ''
      if(placement === 'USERFIELD_TYPE'){
        card_id = placementInfo.options.ENTITY_VALUE_ID
        placement = placementInfo.options.ENTITY_ID+'_FIELDS'
      } else{
        card_id = placementInfo.options.ID
      }

      let card_fields = await Bitrix24.checkIsFields(placement)
      // если поля есть, то обновляем данные
      if(card_fields.is_fields){
        // обновляем данные во всех полях
        let updateCard = await Bitrix24.callMethod(
          'crm.'+card_fields.placement_type+'.update', 
          { id: card_id, 
            fields: { 
              "UF_CRM_TRK_TRANSIT": self.company,
              "UF_CRM_TRK_TRACKER": self.track
            }, 
            params: {
              
            } 
          }
        )
        if(updateCard){
          let domain = BX24.getDomain()
          axios.get(urls.checkTrack(domain, card_id), await common.setAuthorizationHeader()).then(async response => {
            self.isLoad = false
            self.statusClass = 'statusTrue'
            self.alertMessage = 'Информация по трек-номеру успешно обновлена, обновите страницу.'
            // console.log(response.data)
          }).catch(error => {
            let errorParsed = common.errorQueryHandler(error)

            if(errorParsed.type === 'unauthorization'){
              common.queryRefreshToken(error).then(response => {
                self.isLoad = false
                self.statusClass = 'statusTrue'
                self.alertMessage = 'Информация по трек-номеру успешно обновлена, обновите страницу.'
              }).catch(err => {
                self.isLoad = false
                self.statusClass = 'statusFalse'
                self.alertMessage = 'Возникла ошибка: '+common.errorHandler(error)
                console.log(common.errorHandler(error))
              })
            } else if(errorParsed.type === 'some'){
              self.isLoad = false
              self.statusClass = 'statusFalse'
              self.alertMessage = 'Возникла ошибка: '+common.errorHandler(error).error
              console.log(common.errorHandler(error))
            } else{
              self.isLoad = false
              self.statusClass = 'statusFalse'
              self.alertMessage = 'Возникла ошибка: '+common.errorHandler(error)
              console.log(common.errorHandler(error))
            }
          })
        }
      }
    },

    async checkTrack(){
      this.isLoad = true
      await this.saveDataInFields()
    }
  },
}
</script>

<style scoped>
.lastUpdate{
    font-size: 12px;
  }
  .flexRow{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
  }
  .flexRow button{
    margin-right: 5px;
  }
  .flexRow .status{
    flex: 1;
    min-height: 38px;
    height: auto;
    padding: 0 20px;
    line-height: 15px;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: .25rem;
  }
  .statusTrue{
    background-color: #d4edda;
  }
  .statusFalse{
    background-color: #f8d7da;
    position: relative;
  }
  .statusFalse svg{
    position: absolute;
    margin: auto;
    right: 10px;
    cursor: pointer;
  }
  html, body{
    height: 100% !important;
    background-color: #f9fafb !important;
  }
  .mb{
    margin-bottom: 5px;
  }
  #app{
    background-color: #f9fafb !important;
  }
  .panel-app{
    padding: 10px;
    background-color: #f9fafb;
  }
  
  h1{
    display: inline-block !important;
    height: 23px !important;
    color: #525c69 !important;
    vertical-align: middle !important;
    text-transform: uppercase !important;
    font: 600 11px/23px "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    max-width: calc(100% - 30px) !important;
    text-overflow: ellipsis !important;
  }
  a{
    color: #80868e !important;
    text-decoration: none !important;
    white-space: nowrap !important;
    font: 13px/15px "Helvetica Neue",Helvetica,Arial,sans-serif !important;
    cursor: pointer !important;
    transition: 220ms all ease !important;
    &:hover{
      color: #333;
    }
  }
  .form-control{
    display: block !important;
    box-sizing: border-box !important;
    /* padding: 10px 9px !important; */
    min-height: 30px !important;
    height: calc(1.5rem + 0.65rem) !important;
    max-width: 100% !important;
    width: 100% !important;
    outline: 0 !important;
    border: 1px solid #c4c7cc !important;
    border-radius: 1px !important;
    background-color: #fff !important;
    color: #424956 !important;
    font: 15px "Helvetica Neue",Helvetica,Arial,sans-serif !important;
    transition: 220ms all ease !important;
  }
  .tooltip{
    font-size: 12px !important;
  }
  .form-control:focus{
    box-shadow: none !important;
  }
  label{
    color: #a3a9b1;
    font: 12px "Helvetica Neue",Helvetica,Arial,sans-serif;
  }
  .btn{
    background-color: #bbed21 !important;
    outline: none !important;
    padding: 10px 20px !important;
    font-family: Helvetica !important;
    font-size: 12px !important;
    text-transform: uppercase !important;
    color: #535c69 !important;
    font-weight: 600 !important;
    border-radius: 2px !important;
    cursor: pointer !important;
    border: none !important;
    transition: .3s !important;
  }
  .btn:hover{
    background-color: #d2f95f !important;
  }
  .btn:focus{
    box-shadow: none !important;
  }
</style>